import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AlertListModule, TranslateModule } from '@xref/ngx';
import { OmniLoaderModule } from 'src/app/components/omni-loader/omni-loader.module';
import { TAndCRequestBoxModule } from 'src/app/components/t-and-c-request-box/t-and-c-request-box.module';
import { SamlMetadataComponent } from './saml-metadata/saml-metadata.component';

import { SamlSsoComponent } from './saml-sso.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        OmniLoaderModule,
        FormsModule,
        AlertListModule,
        TAndCRequestBoxModule,
    ],
    exports: [],
    declarations: [SamlSsoComponent, SamlMetadataComponent],
    providers: [],
})
export class SamlSsoModule { }
